import { DatePickerInput } from '@mantine/dates';
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import { suspendFormPayload } from '../../../utils/builder/settingDataMerchant';
import Button from '../../elements/Button';
import ImageUploader from '../../fields/ImageUploader';
import Select from '../../fields/SelectBox';
import TextArea from '../../fields/TextArea';
import { fieldsProps } from './schema';
import styles from './styles.scoped.css';

export default function SuspendMerchantForm({
  invalid,
  handleSubmit,
  handleClose,
  // initialValues = {}
}) {
  const { period, reason, dates, photo } = fieldsProps;
  const { values } = useSelector((state) => state.form.formSuspendMerchant);
  const {
    detail: { data },
    suspend: { message, loading, success },
  } = useSelector((state) => state.merchantSetting);
  const [startDate, setStartDate] = useState(dayjs().toDate());
  const [endDate, setEndDate] = useState(dayjs().toDate());
  const showDateField = values.period.includes('Tertentu');

  const onSubmit = async (e) => {
    e.preventDefault();
    const payload = await suspendFormPayload({
      values: { ...values, startDate, endDate },
      withPeriod: showDateField,
    });
    handleSubmit(payload, data?.isSuspend ? 'open-suspend' : '');
  };

  const changeStartDate = (e) => {
    setStartDate(e);
    setEndDate(e);
  };

  return (
    <form
      className={styles.form}
      encType="multipart/form-data"
      onSubmit={onSubmit}
    >
      {message && !success ? <p className={styles.error}>{message}</p> : null}
      {!data?.isSuspend ? (
        <Field
          component={Select}
          data={period.data}
          inputProps={period}
          name={period.name}
        />
      ) : null}
      {showDateField ? (
        <div className={styles.dates}>
          <DatePickerInput
            {...dates}
            minDate={new Date()}
            onChange={changeStartDate}
            value={startDate}
          />
          <span>sampai</span>
          <DatePickerInput
            {...dates}
            minDate={startDate}
            onChange={setEndDate}
            value={endDate}
          />
        </div>
      ) : null}
      <Field
        component={TextArea}
        inputProps={{
          ...reason,
          label: data?.isSuspend ? 'Alasan Membuka Suspend' : 'Alasan Suspend',
        }}
        name={reason.name}
      />
      <Field component={ImageUploader} inputProps={photo} name={photo.name} />
      <div className={styles.actions}>
        <Button
          disabled={loading}
          onClick={handleClose}
          style="default"
          type="button"
        >
          Batal
        </Button>
        <Button
          disabled={invalid || loading}
          style={data?.isSuspend ? 'blue' : 'danger'}
          type="submit"
        >
          {data?.isSuspend ? 'Kirim' : 'Suspend'}
        </Button>
      </div>
    </form>
  );
}

SuspendMerchantForm.propTypes = {
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
};
